import { watchFunctionalComponent } from '~/utils/hyperactiv';
import { unbox } from './logic/logic';

export default watchFunctionalComponent(function Matter(props) {
  const { Component, materializedProps } = props.materialized;
  return (
    <Component {...materializedProps} />
  )
})
